module.exports = __webpack_public_path__ + "static/flight-booking-app-cover-39553e001c827dc7d0800302985e462b.png";